export const ACTION_BUTTON_DEFAULT_TEXT = 'Mark as done';
